import { ArrowDownward } from '@mui/icons-material';
import {
  ServiceLogo,
  type ServiceType,
} from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import {
  type ColumnOption,
  getColumnHeaderList,
  SortFilter,
} from '@public/components/Db/Filters/SortFilter';
import { useRouter } from 'next/router';
import React, { useCallback, useMemo } from 'react';

import styles from './IndustryComparisonColumnHeaderAlt.module.scss';

interface ITeamRosterListHeaderProps {
  selected: ColumnOption;
  columns: ColumnOption[];
  onChange?: React.MouseEventHandler<HTMLButtonElement>;
  ascending: boolean;
  disabled?: boolean;
}
export const IndustryComparisonColumnHeaderAlt = ({
  selected,
  onChange,
  ascending,
  disabled,
  columns,
}: ITeamRosterListHeaderProps) => {
  const router = useRouter();
  const { year } = router.query;
  const isRivalsIndustry = year && +year > 2025;
  const filteredColumns = useMemo(() => {
    if (isRivalsIndustry) {
      return columns.filter((c) => c !== 'Rivals');
    }

    return columns;
  }, [columns, isRivalsIndustry]) as ColumnOption[];
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      onChange?.(e);
    },
    [onChange],
  );

  const headerListSelection = getColumnHeaderList(filteredColumns);

  return (
    <div className={styles.wrapper}>
      <div className={styles.mobileSort}>
        <SortFilter
          ascending={ascending}
          handleSort={handleClick}
          key={`${selected}-${ascending}`}
          selected={selected}
          sortList={headerListSelection}
        />
      </div>
      <header>
        <div className={styles.block} data-rivals-industry={isRivalsIndustry}>
          {headerListSelection.map((item) => {
            const isSelected = item.name === selected;
            const logoType =
              isRivalsIndustry && item.name === 'On3' ? 'Rivals' : item.name;

            return (
              <div
                aria-sort={
                  isSelected ? (ascending ? 'ascending' : 'descending') : 'none'
                }
                className={styles.headerItem}
                id={item.ariaLabel}
                key={item.key}
                role="columnheader"
              >
                <button
                  aria-controls="player-list"
                  data-active={selected === item.name}
                  data-flip={item.flipDirection}
                  data-sorttype={item.name}
                  disabled={disabled}
                  onClick={handleClick}
                >
                  {item.isLogo && (
                    <ServiceLogo type={logoType as ServiceType} />
                  )}
                  {!item.isLogo && <span>{item.displayName}</span>}
                  {isSelected && <ArrowDownward className={styles.arrow} />}
                </button>
              </div>
            );
          })}
        </div>
      </header>
    </div>
  );
};
